// extracted by mini-css-extract-plugin
export default {"container":"ui_container__rlIaP","header":"ui_header__ZMHqy","content":"ui_content__csuIb","form":"ui_form__LDX-x"};